// extracted by mini-css-extract-plugin
export var chip = "_nh-0";
export var icon = "_nh-1";
export var remove = "_nh-2";
export var removeIcon = "_nh-3";